import { ajaxJson } from 'imports/ajax';
import { map2CourseObj } from 'imports/mapper';
import { courseActionCreators } from 'db/course/course.action'
import { createTypes } from 'redux-create-types';


const namespace = 'course-list';

export const courseListActions = createTypes([
    'toggleSpinner',
    'setError',
    'setCourseList'
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: courseListActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}
 
function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: courseListActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function setCourseList(courseIds) {
    return dispatch => {
        dispatch({
            type: courseListActions.setCourseList,
            payload: courseIds
        })
    }
}

function getCoursesApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseListActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('courses'));
    }
}

function getCoursesApiSuccess(res) {
    return dispatch => {
        res.data.results.forEach(course => {
            const courseObj = map2CourseObj(course);
            dispatch(courseActionCreators.save(courseObj))
        });
        const courseIds = res.data.results.map(c => map2CourseObj(c).id);
        dispatch(setCourseList(courseIds));
        return dispatch(hideSpinner('courses'));
    }
}

function getCoursesFromApi() {
    return dispatch => {
        dispatch(showSpinner('courses'))
        return ajaxJson.get('/courses')
        .then(
            res => dispatch(getCoursesApiSuccess(res)),
            err => dispatch(getCoursesApiFail(err))
        )
    }
}

export const courseListActionCreators = {
    getCoursesFromApi,
}